<template>
  <transition name="lxm-transition-fade" mode="out-in">
    <div v-if="show" class="lxm-dialog-container">
      <div class="lxm-dialog">
        <div class="content" v-html="html"></div>
        <div class="has-text-centered">
          <a class="button is-primary lxm-dialog__button" @click="closeClicked">{{ buttonText }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="stylus">
  @import '../styles/index.styl'
  .lxm-dialog-container
    position: fixed
    z-index: 100
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    background-color: rgba(0, 0, 0, 0.5)
    display: flex
    justify-content: center
    align-items: center
  .lxm-dialog
    background-color: white
    border-radius: login-radius
    width: siz(275)
    padding: siz(25) siz(30) siz(40)
    text-align: center
    .content
      p
        // text-align: left
        font-size: size-small
        margin-bottom: siz(25)
        &:last-child
          margin-bottom: siz(30)
      h1
        font-size: size-big
        margin-bottom: siz(25)
      em
        font-size: size
        font-style: normal
  .lxm-dialog__button.button.is-primary
    font-size: size
    border-radius: radius
    background-color: login-primary
    padding: siz(10) siz(25)
    height: siz(35)
    line-height: 1
</style>

<script>
  import * as mTypes from '../../store/mutation-types'
  export default {
    computed: {
      show () {
        return this.html
      },
      html () {
        return this.$store.state.dialogHtml
      },
      buttonText () {
        return this.$store.state.dialogButtonText
      }
    },
    methods: {
      closeClicked () {
        this.$store.commit(mTypes.SET_DIALOG_HTML, null)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmDialog.vue?77857e7c